const INITIAL_STATE = {
    produto: {},
    produtos: [],
    corProduto: [],
    tamanhoProduto: [],
    estampaProduto: [],
    uploadedFiles: [],
    existingFiles: [],
    loading: false,
    processing: false,
    produtoSalvo: false,
}

export default function Produto(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'PRODUTO_PROCESSING' :
            return { ...state, processing: action.payload };
        case 'PRODUTO_LOADING' :
            return { ...state, loading: action.payload };
        case 'PRODUTOS_FETCHED':
            return { ...state, produtos: action.payload }
        case 'PRODUTO_FETCHED':
            return { ...state, produto: action.payload }
        case 'PRODUTO_SAVED':
            return { ...state, produtoSalvo: action.payload };
        case 'COR_PRODUTO_FETCHED':
            return { ...state, corProduto: action.payload }
        case 'TAMANHO_PRODUTO_FETCHED':
            return { ...state, tamanhoProduto: action.payload }
        case 'ESTAMPA_PRODUTO_FETCHED':
            return { ...state, estampaProduto: action.payload }
        case 'EXISTING_FILES':
            return { ...state, existingFiles: action.payload }
        case 'UPLOADED_FILES':
            return { ...state, uploadedFiles: [...action.payload] }
        case 'UPDATE_UPLOADED_FILES':
            const data = action.payload;
            const { uploadedFiles } = state;
            const uploadingFiles = uploadedFiles.map(file => {
                return data.idTemp === file.idTemp ? { ...file, ...data } : file;
            })
            return { ...state, uploadedFiles: uploadingFiles }
        case 'DELETE_UPLOADED_FILE':
            const id = action.payload;
            const files = state.uploadedFiles.filter(file => file.id !== id);
            return { ...state, uploadedFiles: files }
        default:
            return state
    }
}